// Kapito Theme V2

document.addEventListener('DOMContentLoaded', () => {

  // ── PDP image gallery (vertical thumb rail) ────────────
  const mainImg = document.querySelector('#main-product-image');
  const pdpThumbs = document.querySelectorAll('.pdp-gallery__thumb');

  pdpThumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImg) return;
      const src    = thumb.dataset.src;
      const srcset = thumb.dataset.srcset;
      mainImg.src = src;
      if (srcset) mainImg.srcset = srcset;
      mainImg.alt = thumb.dataset.alt || '';
      pdpThumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // ── PDP accordions ──────────────────────────────────────
  document.querySelectorAll('.pdp-accordion__toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.closest('.pdp-accordion').classList.toggle('open');
    });
  });

  // ── Legacy sidebar accordion (kept for any custom pages that reuse it) ──
  document.querySelectorAll('.sidebar-collection-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const parent = btn.closest('.sidebar-collection');
      parent.classList.toggle('open');
    });
  });
  const firstSection = document.querySelector('.sidebar-collection');
  if (firstSection) firstSection.classList.add('open');

  // ── Qty buttons (shared: product form) ─────────────────
  document.querySelectorAll('.qty-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-row').querySelector('.qty-input');
      let v = parseInt(input.value, 10) || 1;
      if (btn.dataset.action === 'minus') v = Math.max(1, v - 1);
      if (btn.dataset.action === 'plus')  v = v + 1;
      input.value = v;
    });
  });

  // ── Shop page: mobile filter drawer toggle ─────────────
  const filterToggles = document.querySelectorAll('[data-shop-filter-toggle]');
  const filterPanel = document.querySelector('[data-shop-filters]');
  if (filterPanel && filterToggles.length) {
    filterToggles.forEach((btn) => {
      btn.addEventListener('click', () => {
        filterPanel.classList.toggle('open');
      });
    });
  }

  // ── Shop page: collapsible filter groups (chevron) ─────
  document.querySelectorAll('[data-shop-filter-group-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.closest('.shop-filter-group').classList.toggle('open');
    });
  });

  // ── Shop page swatch/option active state (visual only; form handles value) ──
  document.querySelectorAll('.pdp-swatch__input').forEach((input) => {
    input.addEventListener('change', () => {
      document.querySelectorAll('.pdp-swatch').forEach((s) => s.classList.remove('active'));
      input.closest('.pdp-swatch').classList.add('active');
    });
  });

  // ── Related products carousel: drag/scroll only (native overflow scroll) ──
  // No JS required — .pdp-related__track uses native horizontal scroll with snap.

});
